var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLevel4Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}.cls-2{fill:#f1f1f1;}.cls-3{fill:#e7e9e8;}.cls-4{fill:#afc07c;}.cls-5{fill:#64783f;}.cls-6{fill:#465425;}.cls-7{fill:#af955c;}.cls-8{fill:#819552;}.cls-9{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "niveau4_selected",
    "data-name": "niveau4 selected"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.89,40.25,9,42h.59A5.53,5.53,0,0,1,9.89,40.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,7.66,10.59,38.91a5.38,5.38,0,0,1,.54-.64l5.34-5.34.1-.14h-1l2.09-3.69H16.4l3.74-6.61,1.54,2.72,4.43-6.58h0L41.82,42H45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.73 17.14 28.67 18.02 29.75 16.84 31.79 18.02 31.97 17.31 32.07 17.37 26.98 7.66 21.55 18.02 24.04 16.26 25.07 18.02 26.73 17.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.43,28.31A5.22,5.22,0,0,1,27,29.84l8.43,8.43A5.24,5.24,0,0,1,37,42h4.84L26.11,18.63l-4.43,6.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.61 32.79 16.57 32.79 16.47 32.94 16.61 32.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35,18.53a1.54,1.54,0,0,1-.12-3.08,1.93,1.93,0,0,1,.49-1.29,1.9,1.9,0,0,1,3.3,1.39,1.32,1.32,0,0,1,.55-.11,1.55,1.55,0,1,1,0,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.22,32.79h-.61l-5.48,5.48A5.27,5.27,0,0,0,9.59,42a6.37,6.37,0,0,1,1.83-2h0a2.49,2.49,0,0,1,2.46-2.09,2.26,2.26,0,0,1,.69.11,3,3,0,0,1,2.76-1.82,3,3,0,0,1,2.16.93v-1.4h-3.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "20.79 38.14 20.79 38.14 20.79 38.14 20.79 38.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.44,38.27,27,29.84a5.22,5.22,0,0,0-3.58-1.53l.45.79H22.61l2.09,3.69H23.06l1.64,2.89H20.79v2.08a3.55,3.55,0,0,1,3.76,1.77h-.11A6.81,6.81,0,0,1,26.89,42H37A5.25,5.25,0,0,0,35.44,38.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.25,27.47a1.54,1.54,0,0,1-.13-3.07,1.86,1.86,0,0,1,.5-1.29,1.9,1.9,0,0,1,3.3,1.38,1.45,1.45,0,0,1,.55-.1,1.54,1.54,0,1,1,0,3.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "23.06 32.79 24.69 35.68 15.58 35.68 17.22 32.79 15.58 32.79 17.67 29.1 16.4 29.1 20.14 22.49 23.87 29.1 22.61 29.1 24.69 32.79 23.06 32.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.23,37.89q.64,0,1.26.06v-.87a3,3,0,0,0-4.92.89,2.33,2.33,0,0,0-.7-.11A2.49,2.49,0,0,0,11.41,40,11.46,11.46,0,0,1,18.23,37.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.43,39.53h.11a3.53,3.53,0,0,0-3.75-1.77v.38A10.91,10.91,0,0,1,24.43,39.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.79,38.14V35.68h-1.3V38C19.93,38,20.37,38.06,20.79,38.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M26.89,42c-1.31-2.4-4.69-4.11-8.66-4.11S10.88,39.6,9.57,42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.8 25.43 23.54 24.48 24.44 25.68 25.9 25.08 27.59 25.68 28.53 24.88 30.32 25.68 30.48 25.2 30.56 25.23 26.11 18.63 21.68 25.21 21.8 25.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevel4Selected);
export default __webpack_public_path__ + "static/media/icon_level_4_selected.2f32cbabed1977960a3dc2174f18ca72.svg";
export { ForwardRef as ReactComponent };